import React from 'react';
import defaultProps from './defaultProps';

export const SortIcon = ({ width, height, ...rest }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 9.18 18'
      className='icon icon-sort'
      {...rest}
    >
      <path
        fill='var(--wild-iris)'
        d='M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15z'
        transform='translate(-7.41 -3)'
      />
    </svg>
  );
};

SortIcon.defaultProps = defaultProps;
